import React from 'react';
import styled from 'styled-components';
const SVG = styled.svg `
  height: ${({ dimensions }) => dimensions}px;
  width: ${({ dimensions }) => dimensions}px;

  path {
    fill: ${({ theme }) => theme.primaryRed};
  }
`;
export const PlusIcon = ({ size }) => {
    if (size === 'medium') {
        return (React.createElement(SVG, { dimensions: 45, width: "45", height: "45", viewBox: "0 0 45 45", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("rect", { x: "3.80774", y: "18.2856", width: "36.9526", height: "8.69474", fill: "#DC2440" }),
            React.createElement("rect", { x: "17.9367", y: "41.1094", width: "36.9526", height: "8.69474", transform: "rotate(-90 17.9367 41.1094)", fill: "#DC2440" })));
    }
    return (React.createElement(SVG, { dimensions: 30, width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { x: "2.25", y: "12", width: "25.5", height: "6", fill: "#DC2440" }),
        React.createElement("rect", { x: "12", y: "27.75", width: "25.5", height: "6", transform: "rotate(-90 12 27.75)", fill: "#DC2440" })));
};
